import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import InDevelopmentPage from "../views/InDevelopment";
import MainPage from "../views/MainPage";
import IndeksKarakterSiswaPage1 from "../views/IndeksKarakterSiswa/IndeksKarakter";
import IndeksKarakterSiswaPage2 from "../views/IndeksKarakterSiswa/PetaSebaran";
import IndeksKarakterSiswaPage3 from "../views/IndeksKarakterSiswa/DetailData";
import PondokPesantrenPage from "../views/PondokPesantren/PetaSebaran";
import PemberdayaanMasyarakatPage from "../views/PondokPesantren/PemberdayaanMasyarakat";
import PenyajianPencarianPage from "../views/PondokPesantren/PenyajianPencarian";
import PendidikanPage from "../views/PondokPesantren/Pendidikan";
import DakwahPage from "../views/PondokPesantren/Dakwah";
import PendidikanMadrasah from "../views/PendidikanMadrasah";
import PendidikanKeagamaan from "../views/PendidikanKeagamaan/Overview";
import PendidikanKeagamaanSDM from "../views/PendidikanKeagamaan/SDM";
import PendidikanKeagamaanSarana from "../views/PendidikanKeagamaan/Sarana";
import PendidikanKeagamaanPendidikan from "../views/PendidikanKeagamaan/Pendidikan";
import PendidikanKeagamaanLembaga from "../views/PendidikanKeagamaan/Lembaga";
import usePageTracking from "./usePageTracking";

const Router = () => {
  usePageTracking();
  return (
    <Switch>
      <Route exact path="/" component={MainPage} />
      <Route
        exact
        path="/indeks-karakter-siswa/1"
        component={IndeksKarakterSiswaPage1}
      />
      <Route
        exact
        path="/indeks-karakter-siswa/2"
        component={IndeksKarakterSiswaPage2}
      />
      <Route
        exact
        path="/indeks-karakter-siswa/3"
        component={IndeksKarakterSiswaPage3}
      />
      <Route exact path="/pondok-pesantren" component={PondokPesantrenPage} />
      <Route
        exact
        path="/pondok-pesantren/pemberdayaan-masyarakat"
        component={PemberdayaanMasyarakatPage}
      />
      <Route
        exact
        path="/pondok-pesantren/penyajian-pencarian"
        component={PenyajianPencarianPage}
      />
      <Route
        exact
        path="/pondok-pesantren/pendidikan"
        component={PendidikanPage}
      />
      <Route exact path="/pondok-pesantren/dakwah" component={DakwahPage} />
      <Route
        exact
        path="/pendidikan-keagamaan/1"
        component={PendidikanKeagamaan}
      />
      <Route
        exact
        path="/pendidikan-keagamaan/2"
        component={PendidikanKeagamaanLembaga}
      />
      <Route
        exact
        path="/pendidikan-keagamaan/3"
        component={PendidikanKeagamaanSDM}
      />
      <Route
        exact
        path="/pendidikan-keagamaan/4"
        component={PendidikanKeagamaanSarana}
      />
      <Route
        exact
        path="/pendidikan-keagamaan/5"
        component={PendidikanKeagamaanPendidikan}
      />
      <Route exact path="/pendidikan-madrasah" component={PendidikanMadrasah} />
      <Route exact path="/on-progress" component={InDevelopmentPage} />
      <Redirect to="/" />
    </Switch>
  );
};

export default Router;
